var modules_1ba53a2f = {"global-search":"_12xmuxr"};
import "../../../assets/Cv7uYQXV.css";

export { modules_1ba53a2f as default };
//# sourceMappingURL=GlobalSearch.module.less.js.map
